import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Shield, ShieldAlert, ShieldCheck, Lock, HardDrive, Zap, Server, Check } from "lucide-react";

export default function Security() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="security-page" className="page-enter pt-24">
      <section className="relative py-20 overflow-hidden" style={{ background: "radial-gradient(ellipse at 50% 0%, rgba(188,19,254,0.12) 0%, transparent 60%), #030305" }}>
        <div className="animated-grid absolute inset-0 opacity-30" />
        <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
          <div className="inline-flex items-center gap-2 mb-6 px-4 py-2 rounded-full text-xs font-rajdhani font-700 tracking-widest"
            style={{ background: "rgba(188,19,254,0.1)", border: "1px solid rgba(188,19,254,0.3)", color: "#BC13FE" }}>
            <Shield size={12} /> ENTERPRISE TRUST CENTER
          </div>
          <h1 className="font-orbitron font-900 text-4xl lg:text-5xl text-white mb-4">
            Security That <span className="text-gradient">Never Sleeps.</span>
          </h1>
          <p className="font-outfit text-base text-gray-400 max-w-2xl mx-auto mb-8">
            Your data is your most valuable asset. Our globally distributed network is protected by military-grade encryption, 
            Tbps-scale DDoS mitigation, and biometrically secured datacenters.
          </p>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 gap-8">
          <div className="glass rounded-2xl p-8 hover:-translate-y-2 transition-transform duration-300">
            <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-6"
              style={{ background: "rgba(0,243,255,0.1)", border: "1px solid rgba(0,243,255,0.2)" }}>
              <ShieldAlert size={24} color="#00F3FF" />
            </div>
            <h3 className="font-rajdhani font-700 text-xl text-white mb-3">1 Tbps DDoS Protection</h3>
            <p className="font-outfit text-sm text-gray-400 leading-relaxed">
              Every IndiaCloud server sits behind advanced Arbor-based Layer 3, 4, and 7 DDoS mitigation. 
              We absorb attacks before your application ever notices a spike in traffic.
            </p>
          </div>
          <div className="glass rounded-2xl p-8 hover:-translate-y-2 transition-transform duration-300">
            <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-6"
              style={{ background: "rgba(188,19,254,0.1)", border: "1px solid rgba(188,19,254,0.2)" }}>
              <Lock size={24} color="#BC13FE" />
            </div>
            <h3 className="font-rajdhani font-700 text-xl text-white mb-3">Data Sovereignty</h3>
            <p className="font-outfit text-sm text-gray-400 leading-relaxed">
              For Indian businesses, compliance is key. Choose our India datacenters to ensure your customer data 
              never leaves the country, fully compliant with MeitY and local privacy laws.
            </p>
          </div>
          <div className="glass rounded-2xl p-8 hover:-translate-y-2 transition-transform duration-300">
            <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-6"
              style={{ background: "rgba(0,255,148,0.1)", border: "1px solid rgba(0,255,148,0.2)" }}>
              <HardDrive size={24} color="#00FF94" />
            </div>
            <h3 className="font-rajdhani font-700 text-xl text-white mb-3">Automated Backups</h3>
            <p className="font-outfit text-sm text-gray-400 leading-relaxed">
              Disaster recovery is built-in. We keep encrypted block-level snapshots and off-site replicas of your infrastructure, 
              allowing 1-click restoration in the event of catastrophic failure.
            </p>
          </div>
        </div>
      </section>

      <section className="py-20" style={{ background: "rgba(10,10,18,0.5)" }}>
        <div className="max-w-5xl mx-auto px-6 text-center">
          <h2 className="font-orbitron font-700 text-3xl text-white mb-12">Built to <span className="text-gradient">Scale.</span> Built to <span className="text-gradient">Last.</span></h2>
          <div className="grid md:grid-cols-2 gap-6 text-left">
            {["ISO 27001 Certified Infrastructure", "PCI-DSS Compliant Network", "SOC 2 Type II Audited Facilities", "100% NVMe PCIe 4.0 Storage", "Redundant 100Gbps Uplinks", "24/7/365 On-site Security Guards"].map((feature) => (
              <div key={feature} className="flex items-center gap-3 p-4 rounded-xl" style={{ border: "1px solid rgba(255,255,255,0.05)", background: "rgba(0,0,0,0.2)" }}>
                <Check size={16} color="#00FF94" className="flex-shrink-0" />
                <span className="font-outfit text-sm text-gray-300">{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 text-center">
        <h3 className="font-orbitron font-700 text-2xl text-white mb-6">Need a custom enterprise architecture?</h3>
        <Link to="/contact">
          <button className="btn-primary px-8 py-3 font-700 flex items-center gap-2 mx-auto">
            <ShieldCheck size={16} /> TALK TO OUR SECURITY TEAM
          </button>
        </Link>
      </section>
    </div>
  );
}
